export const money = value =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

const escapeHtml = text =>
  String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const escapeRegExp = text =>
  String(text).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Los códigos NKR conocidos como links (data-nkr-code: el click lo atiende
// AssistantBubble). Sólo códigos completos: "950-0489" no dentro de
// "950-04891". Los códigos no tienen caracteres que escapar en HTML.
const linkCodes = (html, codes) => {
  if (!codes.length) return html;
  // Escrito en minúsculas por Claude abre igual el código como es
  const canonical = new Map(codes.map(code => [code.toUpperCase(), code]));
  const alternatives = codes
    .slice()
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp)
    .join("|");
  return html.replace(
    new RegExp(`(^|[^\\w-])(${alternatives})(?=[^\\w-]|$)`, "gi"),
    (match, before, written) => {
      const code = canonical.get(written.toUpperCase()) || written;
      return `${before}<a class="nkr-code-link" data-nkr-code="${escapeHtml(
        code
      )}">${written}</a>`;
    }
  );
};

// El poco markdown que usa Claude en respuestas cortas: negrita, código y
// saltos de línea, y los códigos NKR de la conversación como links. Se escapa
// antes, así que es seguro para v-html.
export const formatText = (text, codes = []) =>
  linkCodes(
    escapeHtml(text)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/`([^`]+)`/g, "<code>$1</code>")
      .replace(/\n/g, "<br>"),
    codes
  );
